import { FieldSeparator } from '@/components/ui/field';
import { useStore } from '@tanstack/react-form';
import React from 'react';
import { PhoneField } from './PhoneField';
import { TextField } from './TextField';

export interface SpouseFieldGroupProps {
  form: {
    AppField: React.ComponentType<any>;
    store: any;
  };
  editMode: boolean;
  isLoading?: boolean;
  variant?: 'inline' | 'stacked';
}

export function SpouseFieldGroup({
  form,
  editMode,
  isLoading = false,
  variant = 'inline',
}: SpouseFieldGroupProps) {
  const { AppField } = form;
  const spouseHasCrmAccount = !!useStore(
    form.store,
    (state: any) => (state.values.spouse as any)?.contact_id,
  );
  const effectiveReadOnly = !editMode || spouseHasCrmAccount;

  return (
    <>
      <FieldSeparator className="col-span-full">Spouse</FieldSeparator>

      {editMode && spouseHasCrmAccount && (
        <p className="col-span-full text-sm text-muted-foreground">
          Spouse details can only be updated by an Advisor. Please contact your Advisor, or{' '}
          <a
            href="mailto:info@marshallreddick.com"
            className="text-text-link underline underline-offset-4 hover:text-primary"
          >
            info@marshallreddick.com
          </a>
          , to make changes.
        </p>
      )}

      <AppField name="spouse.first_name">
        {() => (
          <TextField
            label="First Name"
            readOnly={effectiveReadOnly}
            loading={isLoading}
            variant={variant}
          />
        )}
      </AppField>

      <AppField name="spouse.last_name">
        {() => (
          <TextField
            label="Last Name"
            readOnly={effectiveReadOnly}
            loading={isLoading}
            variant={variant}
          />
        )}
      </AppField>

      <AppField name="spouse.email_address">
        {() => (
          <TextField
            label="Email"
            readOnly={effectiveReadOnly}
            loading={isLoading}
            autocomplete="email"
            variant={variant}
          />
        )}
      </AppField>

      <AppField name="spouse.phone_mobile">
        {() => (
          <PhoneField
            label="Mobile Phone"
            readOnly={effectiveReadOnly}
            loading={isLoading}
            variant={variant}
          />
        )}
      </AppField>
    </>
  );
}
